import {FC, PropsWithChildren} from 'react';
import './Buttons.less';

export type ButtonGroupProps = {
    direction: 'row' | 'column' | 'auto';
    position: 'left' | 'center' | 'right' | 'top' | 'bottom';
    wrap?: boolean;
}

const ButtonGroup: FC<PropsWithChildren<ButtonGroupProps>> = props => {
    return (
        <div className={`ButtonGroup ${props.direction ?? 'row'} ${props.position}`} style={{flexWrap: props.wrap ? 'wrap' : 'nowrap'}}>
            {props.children}
        </div>
    );
}

export default ButtonGroup;
